import apiClient from '@/api/ApiClient';

const state = {
  abonnementstyper: [],
  abonnementer: [],
  status: {
    laster: true,
    feiler: false,
    typerLaster: true,
    typerFeiler: false,
    lagringLaster: false,
    lagringFeiler: false,
  },
};

export const getters = {
  filtrerteAbonnementstyper: (state) => state.abonnementstyper.filter((item) => item.utgiver === 'ren'),
  filtrerteAbonnementer: (state, getters) =>
    state.abonnementer.filter((abbo) => {
      return getters.filtrerteAbonnementstyper.some((abTyper) => {
        return abTyper.id === abbo.abonnementstypeId;
      });
    }),
  abonnementerUtenomEidAdresse: (state, getters, rootState) =>
    getters.filtrerteAbonnementer.filter((abbo) => {
      return !rootState.eiendommer.alleEiendommersId.find((id) => {
        return id ? abbo.eksternId.toLowerCase().includes(id.toLowerCase()) : false;
      });
    }),
};

export const actions = {
  async getAbonnementerOgTyper({ dispatch }) {
    await dispatch('getAbonnementstyper');
    await dispatch('getAbonnementer');
  },

  async getAbonnementer({ commit, rootState }) {
    commit('SETT_ABONNEMENTER_LASTER', true);
    commit('SETT_ABONNEMENTER_FEILER', false);

    try {
      const res = await apiClient.getAbonnementer(rootState.representasjoner.currentRepresentation.identifikator);
      if (res) {
        commit('SETT_ABONNEMENTER', res);
      }
    } catch {
      commit('SETT_ABONNEMENTER_FEILER', true);
      commit('SETT_ABONNEMENTER', null);
    }

    commit('SETT_ABONNEMENTER_LASTER', false);
  },

  async getAbonnementstyper({ commit }) {
    commit('SETT_ABONNEMENTSTYPER_LASTER', true);
    commit('SETT_ABONNEMENTSTYPER_FEILER', false);

    try {
      const res = await apiClient.getAbonnementstyper();

      if (res) {
        commit('SETT_ABONNEMENTSTYPER', res);
      }
    } catch {
      commit('SETT_ABONNEMENTSTYPER_FEILER', true);
      commit('SETT_ABONNEMENTSTYPER', null);
    }

    commit('SETT_ABONNEMENTSTYPER_LASTER', false);
  },

  async startAbonnement({ commit, dispatch }, abonnementObj) {
    commit('SETT_LAGRING_LASTER', true);
    try {
      const res = await apiClient.updateAbonnement(abonnementObj);

      if (res) {
        dispatch('leggTilAbonnement', abonnementObj);
        dispatch('avfallOgGjenvinning/leggTilVarsel', abonnementObj, { root: true });
      }
    } catch {
      commit('SETT_LAGRING_FEILER', true);
    }

    commit('SETT_LAGRING_LASTER', false);
  },

  async stoppAbonnement({ commit, dispatch, rootState }, abonnementObj) {
    commit('SETT_LAGRING_LASTER', true);

    try {
      const id = rootState.representasjoner.currentRepresentation.identifikator;
      const res = await apiClient.stopAbonnement(abonnementObj, id);

      if (res) {
        dispatch('fjernAbonnement', abonnementObj);
        dispatch('avfallOgGjenvinning/fjernVarsel', abonnementObj, { root: true });
      }
    } catch {
      commit('SETT_LAGRING_FEILER', true);
    }

    commit('SETT_LAGRING_LASTER', false);
  },

  endreAbonnement({ commit, state }, abonnementObj) {
    const nyttArray = [...state.abonnementer];
    const arrIndex = nyttArray.findIndex(
      (ab) => ab.eksternId === abonnementObj.eksternId && ab.abonnementstypeId === abonnementObj.abonnementstypeId
    );

    if (arrIndex !== 'undefined') {
      nyttArray[arrIndex] = abonnementObj;
      commit('SETT_ABONNEMENTER', nyttArray);
    }
  },

  leggTilAbonnement({ commit, state }, abonnementObj) {
    const nyttArray = [...state.abonnementer];
    nyttArray.push(abonnementObj);

    commit('SETT_ABONNEMENTER', nyttArray);
  },

  fjernAbonnement({ commit, state }, abonnementObj) {
    const abArray = [...state.abonnementer];
    const nyttArray = abArray.filter(
      (ab) => !(ab.eksternId === abonnementObj.eksternId && ab.abonnementstypeId === abonnementObj.abonnementstypeId)
    );

    if (nyttArray) {
      commit('SETT_ABONNEMENTER', nyttArray);
    }
  },
};

export const mutations = {
  SETT_ABONNEMENTER(state, payload) {
    state.abonnementer = payload;
  },
  SETT_ABONNEMENTER_LASTER(state, payload) {
    state.status.laster = payload;
  },
  SETT_ABONNEMENTER_FEILER(state, payload) {
    state.status.feiler = payload;
  },
  SETT_ABONNEMENTSTYPER(state, payload) {
    state.abonnementstyper = payload;
  },
  SETT_ABONNEMENTSTYPER_LASTER(state, payload) {
    state.status.typerLaster = payload;
  },
  SETT_ABONNEMENTSTYPER_FEILER(state, payload) {
    state.status.typerFeiler = payload;
  },
  SETT_LAGRING_LASTER(state, payload) {
    state.status.lagringLaster = payload;
  },
  SETT_LAGRING_FEILER(state, payload) {
    state.status.lagringFeiler = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
